module.exports = __webpack_public_path__ + "static/referencement-eab369046f97b5369bceceacfc36c719.jpg";